<script setup>
import xroadTexts from '~/assets/gql/xroadTexts.gql'
import { useAppStore } from '~/store/main'

const show0 = ref(false)
const show1 = ref(false)
const show2 = ref(false)

const { locale } = useI18n()
const localePath = useLocalePath()
const { internalLinksListener } = useInternalLinkHandler()

const store = useAppStore()
const { getAcademyNav, getStudiumNav, getProgramNav } = storeToRefs(store)

const localeValue = typeof locale === 'object' ? locale.value : locale
const variables = {
  language: localeValue.toUpperCase(),
}

const { data: texts } = await useAsyncQuery(xroadTexts, variables)

const data = computed(() => texts.value?.articles?.nodes[0])

const onScroll = () => {
  const winheight = window.innerHeight

  const top0 = document.querySelector('#reference0')?.offsetTop
  const top0h = document.querySelector('#reference0')?.offsetHeight

  const top1 = document.querySelector('#reference1')?.offsetTop
  const top1h = document.querySelector('#reference1')?.offsetHeight

  const top2 = document.querySelector('#reference2')?.offsetTop
  const top2h = document.querySelector('#reference2')?.offsetHeight

  if (
    window.scrollY + winheight / 2 > top0 &&
    window.scrollY + winheight / 2 < top0 + top0h
  ) {
    show0.value = true
    show1.value = false
    show2.value = false
  } else if (
    window.scrollY + winheight / 2 > top1 &&
    window.scrollY + winheight / 2 < top1 + top1h
  ) {
    show0.value = false
    show1.value = true
    show2.value = false
  } else if (
    window.scrollY + winheight / 2 > top2 &&
    window.scrollY + winheight / 2 < top2 + top2h
  ) {
    show0.value = false
    show1.value = false
    show2.value = true
  } else {
    show0.value = false
    show1.value = false
    show2.value = false
  }
}

onMounted(() => {
  window.addEventListener('scroll', onScroll)

  nextTick(() => {
    if (
      data.value &&
      data.value.GlobalAttributes &&
      data.value.GlobalAttributes.xroadTexts.length
    ) {
      const list = document.querySelectorAll('.mainCategories__row a')
      list.forEach((element) => {
        internalLinksListener(element)
      })
    }
  })
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll)
})
</script>

<template>
  <div
    v-if="
      data && data.GlobalAttributes && data.GlobalAttributes.xroadTexts.length
    "
    ref="text"
    class="mainCategories"
  >
    <div
      v-if="getStudiumNav && getStudiumNav[0] && getStudiumNav[0].connectedNode"
      id="reference0"
      class="mainCategories__row"
    >
      <NuxtLink
        v-if="data.GlobalAttributes?.xroadTexts[0]?.text"
        :to="
          localePath({
            name: 'article-slug',
            params: { slug: getStudiumNav[0].connectedNode.node.slug },
          })
        "
        class="link"
      >
        <span
          class="text_home text0"
          :class="{ show: show0 }"
          v-html="data.GlobalAttributes?.xroadTexts[0]?.text"
        />
      </NuxtLink>
    </div>
    <div
      v-if="getAcademyNav && getAcademyNav[0] && getAcademyNav[0].connectedNode"
      id="reference1"
      class="mainCategories__row"
    >
      <NuxtLink
        v-if="data.GlobalAttributes?.xroadTexts[1]?.text"
        :to="
          localePath({
            name: 'article-slug',
            params: { slug: getAcademyNav[0].connectedNode.node.slug },
          })
        "
        class="link"
      >
        <span
          ref="reference1"
          class="text_home text1"
          :class="{ show: show1 }"
          v-html="data.GlobalAttributes?.xroadTexts[1]?.text"
        />
      </NuxtLink>
    </div>
    <div
      v-if="getProgramNav && getProgramNav[0] && getProgramNav[0].connectedNode"
      id="reference2"
      class="mainCategories__row"
    >
      <NuxtLink
        v-if="data.GlobalAttributes?.xroadTexts[2]?.text"
        :to="
          localePath({
            name: 'article-slug',
            params: { slug: getProgramNav[0].connectedNode.node.slug },
          })
        "
        class="link"
        :class="{ show: show2 }"
      >
        <span
          class="text_home text2"
          v-html="data.GlobalAttributes?.xroadTexts[2]?.text"
        />
      </NuxtLink>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mainCategories {
  &__row {
    padding: 15px 0;
    border-bottom: 1px solid $color-5;
  }
}

.text0 {
  &:deep(a) {
    color: $color-red !important;
  }
  &:deep(p) {
    color: $color-red !important;
    &:hover {
      color: $color-2 !important;
    }
  }
}

.text1 {
  &:deep(a) {
    color: $color-green !important;
  }
  &:deep(p) {
    color: $color-green !important;
    &:hover {
      color: $color-2 !important;
    }
  }
}

.text2 {
  &:deep(a) {
    color: $color-blue !important;
  }
  &:deep(p) {
    color: $color-blue !important;
    &:hover {
      color: $color-2 !important;
    }
  }
}

.show {
  &:deep(p) {
    color: $color-2 !important;
    &:hover {
      color: $color-2 !important;
    }
  }
}
</style>
